import React from "react";
import { AppList } from "components/list/AppList";
import { Datagrid, TextField } from 'react-admin';

import { DatagridWithBlockDeleteProps } from "../../../components/_helpers/props/DatagridProps";
import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import { CommoditiesFilter } from './ListFilters';
import { SelectEnumField } from "components/fields/SelectEnumField";
import { CommodityCategory } from "entities/CommodityCategory";
import DeleteRestoreButtons from "components/toolbars/DeleteRestoreButtons";
import { DeleteButton } from "components/toolbars/DeleteButton";

const defaultSort = { field: 'name', order: 'ASC' };

const CustomSoftDeleteRestoreButton = (props) => {
	if (props.record.is_deleted) {
		return <DeleteRestoreButtons {...props} />;
	}
	return null;
};

const CustomHardDeleteRestoreButton = (props) => {
	if (!props.record.is_deleted) {
		return (
			<DeleteButton 
				resource={props.resource}
				notifyMessage="osfc.dialogs.confirm_delete_entity.success"
				title="osfc.dialogs.confirm_delete_entity.title"
				content="osfc.dialogs.confirm_delete_entity.content"
			/>
		);
	}
	return null;
};

export const CommoditiesList = ({permissions, ...props}) => {
	const classes = stylesForColorInheritInList();

	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			classes={classes}
			filters={<CommoditiesFilter />}
		>
			<ScrollingWrapper>
				<Datagrid
					{...DatagridWithBlockDeleteProps}
					rowClick="edit"
				>
					<TextField source="id" />
					<TextField source="name" />
					<SelectEnumField source="category" enumName="commodity-category" enumObj={CommodityCategory} />
					<CustomSoftDeleteRestoreButton />
					<CustomHardDeleteRestoreButton />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
